module.exports = __webpack_public_path__ + "img/bank_of_china.e6fc66fa.png";